let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { AVATAR_BACKGROUND_COLOR_THEME_KEY } from '../../Constants';
import SVGWrapperBase from './SVGWrapperBase';
export default styledWithTheme(SVGWrapperBase)(_t || (_t = _`
  fill: currentColor;
  font-size: 290%;
  ${0};
`), ({
  src,
  theme
}) => src ? `background-image: url('${src}');` : `background-color: ${theme.color[AVATAR_BACKGROUND_COLOR_THEME_KEY]};`);